import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ceoStoreData } from "../../sample-data";

const initialState = {
  data: [],
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;

export const fetchCeoStore = createAsyncThunk(
  "CeoStore/fetchCeoStore",
  async (thunkApi, { rejectWithValue }) => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    return ceoStoreData;
    try {
      const response = await axios.get(url, {
        validateStatus: (status) => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceCeoStore = createSlice({
  name: "CeoStore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCeoStore.pending, (state) => {
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchCeoStore.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchCeoStore.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectCeoStoreData = (state) => state.CeoStore.data;
export const selectIsLoading = (state) => state.CeoStore.isLoading;
export const selectError = (state) => state.CeoStore.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.CeoStore.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.CeoStore.data,
  isLoading: state.CeoStore.isLoading,
  error: state.CeoStore.error,
}));
*/
export default sliceCeoStore.reducer; // Export the reducer
